import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Categories from '@/components/Categories'
import Category from '@/components/Category'
import Configuration from '@/components/Configuration'
import Ads from '@/components/Ads'
import Profile from '@/components/Profile'
import InsertCreative from '@/components/InsertCreative'
import Demo from '@/components/Demo'
import Administrator from '@/components/Administrator'
import EnterpriseForm from '@/components/EnterpriseForm'
import ClientPreview from '@/components/ClientPreview'
import SelfServeUpdates from "@/components/SelfServeUpdates";
import UpdateSuccess from "@/components/UpdateSuccess";
import NotFound from "@/components/NotFound";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/categories',
      name: 'Categories',
      component: Categories
    },
    {
      path: '/categories/:id',
      name: 'Category',
      component: Category
    },
    {
      path: '/configuration/:format_id',
      name: 'Configuration',
      component: Configuration
    },
    {
      path: '/configuration/:format_id/:id',
      name: 'Configuration',
      component: Configuration
    },
    {
      path: '/ads',
      name: 'Ads',
      component: Ads
    },
    {
      path: '/demo/:format_id',
      name: 'Demo',
      component: Demo
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/insert-creative',
      name: 'Insert Creative',
      component: InsertCreative
    },
    {
      path: '/admin',
      name: 'Administrator',
      component: Administrator
    },
    {
      path: '/quote',
      name: 'EnterpriseForm',
      component: EnterpriseForm
    },
    {
      path: '/clientpreview',
      name: 'Client Preview',
      component: ClientPreview
    },
    {
      path: '/updates/:format_id/:advertisement_id',
      name: 'Self Serve Updates',
      component: SelfServeUpdates
    },
    {
      path: '/update_success',
      name: 'UpdateSuccess',
      component: UpdateSuccess
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Home
    },
    {
      path: '*',
      name: 'Default/Not Found',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js